import { render, staticRenderFns } from "./BuZhiModal.vue?vue&type=template&id=1faee1a6&"
import script from "./BuZhiModal.vue?vue&type=script&lang=js&"
export * from "./BuZhiModal.vue?vue&type=script&lang=js&"
import style0 from "./BuZhiModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports